/* eslint-disable jsx-a11y/anchor-is-valid */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Columns, Image, EditSquare, Times } from '../../../components/Icon';
import { Button } from '../../../components/Buttons';
import { fetchHexonImagesFor, hexonCreateAd, hexonDeleteAd, hexonRecreateImages } from '../../Vehicles/actions';
import { selectWorks } from '../../Api/selectors';
import { Loader } from '../../../components/Loader';
import { selectHexonImagesFor } from '../../Vehicles/selectors';

const Container = styled.div`
  text-align: left;
  &.spaced {
    border-top: 1px solid #ddd;
    margin-top: 12px;
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class HexonAdsItemComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    return (
      <Container className={`${this.props.spaced ? 'spaced' : ''}`}>
        <HBox left vCenter>
          {this.renderBody()}
        </HBox>
      </Container>
    );
  }

  renderBody() {
    const ad = this.props.ad;
    if (this.props.loading) return <Loader small />;
    return (
      <>
        {this.props.images?.[0] ? <img width="90" src={this.props.images[0].image_url} /> : null}
        <div style={{ width: '180px' }}>
          <a href="#" onClick={this.tofn(`vehicles/${ad.stocknumber}/hexon`)}>
            {ad.stocknumber}
          </a>
        </div>
        <div style={{ width: '230px' }}>{ad.site_code}</div>

        <div style={{ width: '180px' }}>{dayjs(ad.last_added).format('DD-MM-YYYY')}</div>
        <div style={{ width: '40px' }}>
          {ad.advertised_url ? (
            <a href={ad.advertised_url} target="_blank">
              link
            </a>
          ) : null}
        </div>
        <div style={{ width: '40px' }}>
          {ad.deeplinks ? (
            <a href={ad.deeplinks} target="_blank">
              link
            </a>
          ) : null}
        </div>
        <div>
          <Button
            small
            onClick={() => {
              this.props.createAd(parseInt(ad.stocknumber, 10), ad.site_code);
            }}
          >
            <EditSquare />
          </Button>
          <Button small onClick={this.props.createImages}>
            <EditSquare />
            <Image />
          </Button>
          <Button warning small onClick={this.props.delete}>
            <Times />
          </Button>
        </div>
      </>
    );
  }
}

HexonAdsItemComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWorks([`HEXON-${ownProps.ad.stocknumber}-${ownProps.ad.site_code}`, `HEXON-${ownProps.ad.stocknumber}`]),
    images: selectHexonImagesFor(ownProps.ad.stocknumber),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchHexonImagesFor(ownProps.ad.stocknumber));
    },
    createAd(vehicleId, site_code, callback) {
      dispatch(hexonCreateAd(vehicleId, site_code, callback));
    },
    createImages() {
      dispatch(hexonRecreateImages(ownProps.ad.stocknumber));
    },
    delete() {
      dispatch(hexonDeleteAd(vehicleId, site_code, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const HexonAdsItem = compose(
  withRouter,
  withConnect,
)(HexonAdsItemComp);
